export const opsMgmtMenuDefs = [
    {
        "name": "menu.test_cases",
        "resource": "test_cases",
        "icon": "fa fa-user-md",
        "url": "test_cases",
        "auto_crud": true,
        "showMenu": false
    }
]